import React from "react";
import { InBodyAds } from "@bloomberg/media-ui-ads";
import { classes } from "@bloomberg/media-ui-core";

import { SparkleAdOptions } from "@foundation/sparkle/lib/types";
import { useFortress } from "@foundation/fortress";
import styles from "./styles.module.css";
import { getFortressState } from "~utils/getFortressState";

type InBodyAds = {
  className?: string;
};

const adOptions: SparkleAdOptions = {
  dimensions: {
    all: [
      [300, 250],
      [3, 3],
      [5, 24],
    ],
    large_desktop: [[5, 16]],
    small_desktop: [[5, 16]],
    mobile: [[3, 4]],
  },
};

export default function BazaarInBodyAd(props: InBodyAds) {
  const { className } = props;
  const fortressContext = useFortress();
  const { isAllowed } = getFortressState(fortressContext);

  if (!isAllowed) {
    return null;
  }

  return (
    <InBodyAds
      className={classes([styles.inBodyAd, className])}
      adOptions={adOptions}
    />
  );
}
